import React, { useEffect, useState } from "react";
import CommonTable from "../common/CommonTable";
import CommonModal from "../common/CommonModal";
import { useNavigate } from "react-router-dom";
import { useUser } from "../Commonfunction/UserContext";
import { getData } from "../Commonfunction/CommonFunction";
import { checkPermission } from "../Commonfunction/NewPermission";
import TopHeading from "../common/TopHeading";
import PermissionMessage from "../common/PermissionMessage";
import DeleteConfirmationModal from "../common/DeleteConfirmationModal";
import { TbEdit } from "react-icons/tb";
import { RiDeleteBin6Line } from "react-icons/ri";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css"; // Importing toast styles

import moment from "moment";
import FinancialYearForm from "../Forms/FinancialYearForm";

export default function FinancialYear() {
  const { setUserAccess, role } = useUser();
  console.log("role", role);
  const [permissionsData, setPermissionsData] = useState();
  const [tableData, setTableData] = useState([]);
  const [rowId, setRowId] = useState();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [permissionMassage, setPermissionMassage] = useState(false);

  const handleClose = () => {
    setShowModal(false);
    setRowId();
  };

  // Define columns with action column correctly structured
  const columns = [
    {
      key: "action",
      label: "Action",
      sortable: false,
      renderCell: (params) => (
        <div style={{ display: "flex", width: "100%" }}>
          <div
            className="action-buttons"
            style={{ display: "flex", gap: "10px" }}
          >
            <button
              className="edit-btn"
              onClick={() => {
                fetchDataUserAccess("edit", true, params, "");
              }}
            >
              <TbEdit size={18} />
            </button>
            <button
              className="delete-btn"
              onClick={() => fetchDataUserAccess("delete", true, params, "")}
            >
              <RiDeleteBin6Line size={18} />
            </button>
          </div>
        </div>
      ),
    },
    { key: "financial_start_date", label: "Financial Start", sortable: true },
    { key: "financial_end_date", label: "Financial End", sortable: true },
  ];

  const fetchDataUserAccess = async (method, showPopup, params, goToLink) => {
    console.log("method", method);
    try {
      const result = await getData("/api/user-access");
      if (result.success) {
        setUserAccess(result);
        console.log(
          "==>",
          role,
          method,
          result.permission,
          checkPermission(role, method, result.permission)
        );
        checkPermission(role, method, result.permission)
          ? showPopup
            ? method == "delete"
              ? (setOpen(true), setRowId(params.id))
              : params
              ? (setRowId(params.id), setShowModal(true))
              : (setRowId(null), setShowModal(true))
            : goToLink
            ? navigate(goToLink)
            : ""
          : setPermissionMassage(true);
      }
    } catch (error) {
      console.log("Error:123213", error);
    }
  };

  const fetchData = async () => {
    try {
      const result = await getData("/api/all-financial-year");
      if (result.success) {
        setTableData(result.data);
        if (!checkPermission("FinancialYear", "view", result.permission)) {
          setPermissionMassage(true);
          setTimeout(() => {
            navigate("/");
          }, 2000);
        }
      } else {
        toast.error(result.message);
      }
    } catch (error) {
      console.log("Error: ", error);
    }
  };
  const indexedRows =
    tableData?.length > 0 &&
    tableData?.map((data, index) => ({
      index: index + 1,
      id: data.id,
      // cpc_name: data?.cpc_name,
      financial_start_date: moment(data?.financial_start).format("MM/DD/YYYY"),
      financial_end_date: moment(data?.financial_end).format("MM/DD/YYYY"),
    }));
  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div className="usa-prose">
      <TopHeading
        // heading="Financial Year"
        setShowModal={() => {
          fetchDataUserAccess("add", true, "", "");
        }}
        isHideBtn={true}
      />
      <CommonTable columns={columns} data={indexedRows || []} />
      {open && (
        <DeleteConfirmationModal
          open={true}
          handleClose={() => setOpen(false)}
          request_url={`/api/delete-financial-year/${rowId}`}
          getApi={fetchData}
        />
      )}
      {showModal && (
        <CommonModal
          isOpen={showModal}
          onClose={handleClose}
          title={rowId ? "Edit Financial Year" : "Add Financial Year"}
        >
          <FinancialYearForm
            onClose={handleClose}
            id={rowId}
            fetchData={fetchData}
          />
        </CommonModal>
      )}
      {permissionMassage && (
        <PermissionMessage
          open={true}
          handleClose={() => {
            setPermissionMassage(false);
          }}
        />
      )}
    </div>
  );
}
